import { render, staticRenderFns } from "./grantListSeeDetailed.vue?vue&type=template&id=32c8c62e&scoped=true"
import script from "./grantListSeeDetailed.vue?vue&type=script&lang=js"
export * from "./grantListSeeDetailed.vue?vue&type=script&lang=js"
import style0 from "./grantListSeeDetailed.vue?vue&type=style&index=0&id=32c8c62e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c8c62e",
  null
  
)

export default component.exports